// extracted by mini-css-extract-plugin
export default {"chips":"bt-chip-list_chips__JXtBL","chip":"bt-chip-list_chip__o7iyc"};